// extracted by mini-css-extract-plugin
export default {"wrapper":"AboutPros_wrapper__IGaKn","scroll":"AboutPros_scroll__4GnoM","carousel":"AboutPros_carousel__Z8uZA","slide":"AboutPros_slide__mDo8i","card":"AboutPros_card__yUsbK"};